/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgRadio = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M21 7.5Q21 6 19.5 6h-10l7-2.5L16 2 4.28 6.13C3.53 6.42 3 6.65 3 7.5v12Q3 21 4.5 21h15q1.5 0 1.5-1.5zm-16.5 0h15V12h-3v-2H15v2H4.5zM7 19a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" clipRule="evenodd" /></svg>;
export default SvgRadio;